import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from '../views/Index.vue'
import Home from '../views/Home.vue'
import Carousel from '../views/Carousel.vue'
import Login from '../views/Login.vue'
import GoodsClassify from '../views/GoodsClassify.vue'
import GoodsNorms from '../views/GoodsNorms.vue'
import Goods from '../views/Goods.vue'
import Test from '../views/Test.vue'
import Order from '../views/Order.vue'
import User from '../views/User.vue'
import Data from '../views/Data.vue'
Vue.use(VueRouter)
const routes = [
  {
    path: '/index',
    name: 'index',
	component:Index,
  },
  {
    path: '/',
    name: 'login',
  	component:Login,
  },
  {
    path: '/home',
    name: 'home',
  	component:Home,
	children:[
		{
		  path: '/carousel',
		  name: 'carousel',
		  component:Carousel,
		},
		{
		  path: '/goodsclassify',
		  name: 'goodsclassify',
		  component:GoodsClassify,
		},
		{
		  path: '/goodsnorms',
		  name: 'goodsnorms',
		  component:GoodsNorms,
		},
		{
		  path: '/goods',
		  name: 'goods',
		  component:Goods,
		},
		{
		  path: '/test',
		  name: 'test',
		  component:Test,
		},
		{
		  path: '/order',
		  name: 'order',
		  component:Order,
		},
		{
		  path: '/user',
		  name: 'user',
		  component:User,
		},
		{
		  path: '/data',
		  name: 'data',
		  component:Data,
		},
	]
  },
]
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }

const router = new VueRouter({
  routes
})

export default router
